import { gql, useQuery } from '@apollo/client'

const useEducatorsNeedingObservation = (vars = {}) => {
    const { data, loading, error, refetch } = useQuery(
        gql`
        query {
            getEducatorsToObserve {
                _id
                avatar
                email
                firstName
                lastName
                educatorInfo {
                    frecuencyObservations
                    observationsDates {
                        date
                        staffId
                        staffName
                        }
                    observationsBy {
                        staffId
                        staffName
                    }
                }
                nextObservationDate
                lastObservationDate
                lessons {
                    ... on IndividualLesson {
                            id
                            title
                            status
                            recordingUrl
                            startDate
                            individualStudent: student {
                                firstName
                                lastName
                            }
                    }
                    ... on PlanLesson {
                            id
                            title
                            status
                            recordingUrl
                            startDate
                            planStudent: student {
                                firstName
                                lastName
                            }
                    }
                    ... on GroupLesson {
                            id
                            title
                            status
                            recordingUrl
                            startDate
                            students {
                                firstName
                                lastName
                            }
                    }
                }

            }  
        }`,
        {
            variables: vars,
            fetchPolicy: 'cache-first',
        }
    );

    return { data: data ? data.getEducatorsToObserve : [], loading, error, refetch };
}

export default useEducatorsNeedingObservation;